import React from 'react';
import { IQuestion } from '@/components/staffer/Grading/types';
import { renderStimuli } from '@/components/staffer/Grading/utils';

interface PromptOnlyQuestionCardProps {
  question: IQuestion;
}

const PromptOnlyQuestionCard = ({ question }: PromptOnlyQuestionCardProps) => (
  <>
    <div
      className="tw-my-5"
      dangerouslySetInnerHTML={{ __html: question.sanitized_body }}
    />
    {renderStimuli(question)}
  </>
);

export default PromptOnlyQuestionCard;
